export default {
  heading: 'Titillium Web, sans-serif',
  body: 'Open Sans, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Orbitron, serif',
  googleFonts: [
    'Orbitron:400,500,600,700,800,900',
    'Titillium Web:200,300,400,500,600,700,800,900',
    'Open Sans:300,400,500,600,700,800,900'
  ]
  // customFamilies: [''],
  // customUrls: [''],
}
